import type { ComponentType } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { componentWithCondition } from '../component-with-condition/index.tsx';

export const componentWithFF = <A extends {}, B extends {}>(
	featureFlagName: string,
	ComponentTrue: ComponentType<A>,
	ComponentFalse: ComponentType<B>,
) => componentWithCondition(() => ff(featureFlagName), ComponentTrue, ComponentFalse);
